/*
 * @Description:
 * @Author: 姓名
 * @Date: 2024-08-30 17:28:21
 * @LastEditTime: 2025-10-10 14:46:45
 * @LastEditors: yongqiang
 */

export const VERIFY_AUTH_DEFAULT_CONFIG = {
  resultCodes: {
    truth: [
      {
        value: 0,
        note: '结果为真'
      }
    ],
    fake: [
      {
        value: -6002,
        note: 'cheatAppWarning'
      },
      {
        value: -6003,
        note: '时间虚假、地点虚假、防伪码真实'
      },
      {
        value: -6004,
        note: '地点虚假'
      },
      {
        value: -6005,
        note: '地点虚假'
      },
      {
        value: -6006,
        note: 'cheatAppWarning'
      },
      {
        value: -2303,
        note: '伪造防伪码'
      },
      {
        value: -2403,
        note: 'cheatAppWarning'
      },
      {
        value: -3003,
        note: 'cheatAppWarning'
      },
      {
        value: -7001,
        note: '照片经过了处理/编辑'
      },
      {
        value: -7002,
        note: '照片经过了处理/编辑'
      },
      {
        value: -7003,
        note: '照片经过了处理/编辑'
      },
      {
        value: -7004,
        note: '照片经过了处理/编辑'
      },
      {
        value: -7005,
        note: '照片经过了处理/编辑'
      },
      {
        value: -7006,
        note: '照片经过了处理/编辑'
      },
      {
        value: -7007,
        note: '照片经过了处理/编辑'
      },
      {
        value: -7008,
        note: 'cheatAppWarning'
      },
      {
        value: -8001,
        note: '作弊软件拍摄或伪造照片不可信'
      },
      {
        value: -8002,
        note: '作弊软件拍摄或伪造照片不可信'
      },
      {
        value: -8003,
        note: 'cheatAppWarning'
      },
      {
        value: -8004,
        note: '作弊软件拍摄或伪造照片不可信'
      },
      {
        value: -8005,
        note: '作弊软件拍摄或伪造照片不可信'
      },
      {
        value: -8006,
        note: 'cheatAppWarning'
      },
      {
        value: -8007,
        note: '作弊软件拍摄或伪造照片不可信'
      },
      {
        value: -8008,
        note: '作弊软件拍摄或伪造照片不可信'
      },
      {
        value: -8009,
        note: '作弊软件拍摄或伪造照片不可信'
      },
      {
        value: -9001,
        note: '作弊软件拍摄或伪造照片不可信'
      }
    ],
    unknown: [
      {
        value: -1,
        note: 'supportAntiCodeCheck'
      },
      {
        value: -2305,
        note: 'supportAntiCodeCheck'
      },
      {
        value: -2200,
        note: 'supportAntiCodeCheck'
      },
      {
        value: -2301,
        note: 'supportAntiCodeCheck'
      },
      {
        value: -2306,
        note: 'supportAntiCodeCheck'
      },
      {
        value: -6001,
        note: '无法鉴别'
      },
      {
        value: -10002,
        note: '无法鉴别'
      },
      {
        value: -1003,
        note: '检测出现异常'
      },
      {
        value: -2400,
        note: '检测出现异常'
      },
      {
        value: -2401,
        note: '检测出现异常'
      },
      {
        value: -4001,
        note: '检测出现异常'
      },
      {
        value: -4006,
        note: '检测出现异常'
      },
      {
        value: -4007,
        note: '检测出现异常'
      },
      {
        value: -4008,
        note: '检测出现异常'
      },
      {
        value: -4009,
        note: '检测出现异常'
      },
      {
        value: -4010,
        note: '检测出现异常'
      },
      {
        value: -5001,
        note: '检测出现异常'
      },
      {
        value: -5002,
        note: '检测出现异常'
      },
      {
        value: -2307,
        note: '版本超过180天'
      }
    ],
    serverException: [
      {
        value: -1001,
        note: '代码、服务异常'
      },
      {
        value: -1002,
        note: '代码服务异常'
      },
      {
        value: -2300,
        note: '代码服务异常'
      },
      {
        value: -2302,
        note: '代码服务异常'
      },
      {
        value: -2100,
        note: '代码服务异常'
      },
      {
        value: -2500,
        note: '代码服务异常'
      },
      {
        value: -3002,
        note: '代码服务异常'
      },
      {
        value: -4002,
        note: '代码服务异常'
      }
    ]
  },
  truthConfigs: {
    resultImage: {
      url:
        'https://static.xhey.top/verify-config/cd8af238-ead1-49ff-87f1-57e793130e20.png',
      width: 136,
      height: 40
    },
    stampImage: {
      url: '',
      x: 176,
      y: 10
    },
    certStampImage: {
      url:
        'https://static.xhey.top/verify-config/226d3268-2f84-4830-81f2-b83e9be245e1.png',
      width: 80,
      height: 80,
      x: 225,
      y: 1
    },
    scenes: [
      {
        codes: ['0'],
        features: [
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '时间真实',
            content: '{{PhotoTime}}',
            defaultContent: '拍摄人未开启时间拍照',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '地点真实',
            content: '{{PhotoAddress}}',
            defaultContent: '拍摄人未开启定位拍照',
            fallback: {
              icon: 'notice',
              customIcon: '',
              color: '#B0B0B0',
              title: '地点未知',
              content: '拍摄人未开启定位拍照'
            },
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          }
        ]
      }
    ]
  },
  fakeConfigs: {
    resultImage: {
      url:
        'https://static.xhey.top/verify-config/9fcb6417-5dd7-42ad-8a5f-1c20a1fb2bf2.png',
      width: 136,
      height: 39
    },
    stampImage: {
      url:
        'https://static.xhey.top/verify-config/fa5d5443-a3cf-4277-981c-ca5ae6aa6993.png',
      width: 107,
      height: 66,
      x: 202,
      y: 10
    },
    reportCheaterConfig: {
      enable: true,
      text: '举报作弊人'
    },
    antiCheatConfig: {
      enable: true,
      codes: ['-2403', '-3003', '-8003', '-8006', '-6006', '-6002', '-7008'],
      image: {
        url:
          'https://static.xhey.top/verify-config/de1eec9d-e10b-42dc-8785-aab35558351f.png',
        width: 300,
        height: 243
      }
    },
    scenes: [
      {
        codes: ['-6002'],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时间虚假',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'notice',
            customIcon: '',
            color: '#b0b0b0',
            title: '地点未知',
            content: '拍摄人未开启定位拍照',
            defaultContent: ''
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          }
        ]
      },
      {
        codes: ['-6003'],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时间虚假',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '地点虚假',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          }
        ]
      },
      {
        codes: ['-6004'],
        features: [
          {
            icon: 'warning',
            customIcon: '',
            color: '#faad14',
            title: '时        间',
            content: '拍摄人未开启时间拍照',
            defaultContent: ''
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '地点虚假',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          }
        ]
      },
      {
        codes: ['-6005'],
        features: [
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '时间真实',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '地点虚假',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            fallback: {
              icon: 'error',
              customIcon: '',
              color: '#F4475C',
              title: '地点虚假',
              content: '无定位，水印地址为拍照后添加'
            }
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          }
        ]
      },
      {
        codes: ['-6006'],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时间虚假',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '地点真实',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          }
        ]
      },
      {
        codes: ['-2303', '-2403', '-3003'],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时        间',
            content: '时间不可信',
            defaultContent: ''
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '地        点',
            content: '地点不可信',
            defaultContent: ''
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '伪造防伪码',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          }
        ]
      },
      {
        codes: ['-7001'],
        features: [
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '时间真实',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'notice',
            customIcon: '',
            color: '#b0b0b0',
            title: '地点未知',
            content: '拍摄人未开启定位拍照',
            defaultContent: ''
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: "照片经过了处理/编辑'",
            defaultContent: ''
          }
        ]
      },
      {
        codes: ['-7002'],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时间虚假',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'notice',
            customIcon: '',
            color: '#b0b0b0',
            title: '地点未知',
            content: '拍摄人未开启定位拍照',
            defaultContent: ''
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: '照片经过了处理/编辑',
            defaultContent: ''
          }
        ]
      },
      {
        codes: ['-7003'],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时间虚假',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '地点虚假',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: '照片经过了处理/编辑',
            defaultContent: ''
          }
        ]
      },
      {
        codes: ['-7004'],
        features: [
          {
            icon: 'warning',
            customIcon: '',
            color: '#faad14',
            title: '时间',
            content: '拍摄人未开启时间拍照',
            defaultContent: ''
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '地点虚假',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: '照片经过了处理/编辑',
            defaultContent: ''
          }
        ]
      },
      {
        codes: ['-7005'],
        features: [
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '时间真实',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '地点虚假',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: '照片经过了处理/编辑',
            defaultContent: ''
          }
        ]
      },
      {
        codes: ['-7006'],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时间虚假',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '地点真实',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: '照片经过了处理/编辑',
            defaultContent: ''
          }
        ]
      },
      {
        codes: ['-7007'],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时        间',
            content: '拍摄人未开启时间拍照',
            defaultContent: ''
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '地点真实',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: '照片经过了处理/编辑',
            defaultContent: ''
          }
        ]
      },
      {
        codes: ['-7008'],
        features: [
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '时间真实',
            content: '{{PhotoTime}}',
            defaultContent: '',
            valueKey: 'PhotoTime'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '地点真实',
            content: '{{PhotoAddress}}',
            defaultContent: '',
            valueKey: 'PhotoAddress'
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: '经过处理/PS/拼图/截图',
            defaultContent: ''
          }
        ]
      },
      {
        codes: [
          '-8001',
          '-8002',
          '-8003',
          '-8004',
          '-8005',
          '-8006',
          '-8007',
          '-8008',
          '-8009',
          '-9001'
        ],
        features: [
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '时        间',
            content: '时间不可信',
            defaultContent: ''
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '地        点',
            content: '地点不可信',
            defaultContent: ''
          },
          {
            icon: 'right',
            customIcon: '',
            color: '#47EA84',
            title: '防伪码真实',
            content: '{{PhotoExt.antiFakeCode}}',
            defaultContent: '',
            valueKey: 'antiFakeCode'
          },
          {
            icon: 'error',
            customIcon: '',
            color: '#f4475c',
            title: '实际照片',
            content: '作弊软件拍摄或伪造照片不可信',
            defaultContent: ''
          }
        ]
      }
    ]
  },
  unknownConfigs: {
    resultImage: {
      url:
        'https://static.xhey.top/verify-config/10b341db-da05-46a5-9f68-aa17859e56d5.png',
      width: 136,
      height: 38
    },
    stampImage: {
      url:
        'https://static.xhey.top/verify-config/d7b48222-acc5-4da2-bf61-b3f1131849bb.png',
      width: 107,
      height: 66,
      x: 202,
      y: 10
    },
    antiCheatConfig: {
      enable: true,
      codes: [-1, -2305, -2200, -2301, -2306],
      image: {}
    },
    scenes: [
      {
        codes: ['-1'],
        title: '照片分辨率过低，不支持验真',
        description: '请使用下载未经过压缩的“今日水印相机”照片',
        actions: ['antiCodeCheck'],
        image: {
          url:
            'https://static.xhey.top/verify-config/0f62faab-5c6c-48d8-9cec-45f1a3ee3c14.png',
          width: 120,
          height: 120
        },
        cardImage: {}
      },
      {
        codes: ['-2305'],
        title: '无水印/非今日水印相机拍摄，不支持验真',
        description: '仅支持验证带水印和防伪码的今日水印照片',
        actions: ['antiCodeCheck'],
        image: {},
        cardImage: {}
      },
      {
        codes: ['-2306'],
        title: '非正常尺寸的图片，不支持验真',
        description: '可能是截屏/裁切图/拼图等',
        actions: ['antiCodeCheck'],
        image: {},
        cardImage: {}
      },
      {
        codes: ['-2200', '-2301'],
        title: '未发现照片防伪码，不支持验真',
        description: '仅支持验证带水印和防伪码的今日水印照片',
        actions: ['antiCodeCheck'],
        image: {
          url: ''
        },
        cardImage: {}
      },
      {
        codes: ['-6001'],
        title: '用户未开启时间/地点拍照，不支持验真',
        description: '',
        actions: ['antiCodeCheck'],
        image: {},
        cardImage: {}
      },
      {
        codes: [
          '-1003',
          '-2400',
          '-2401',
          '-4006',
          '-4001',
          '-4007',
          '-4008',
          '-4009',
          '-4010',
          '-5001',
          '-5002'
        ],
        title: '检测出现异常',
        description: '系统无法判断真假，请联系客服人工验真',
        actions: ['antiCodeCheck'],
        image: {},
        cardImage: {}
      },
      {
        codes: ['-10002'],
        title: '该照片由作弊设备生成',
        description: '',
        actions: [],
        image: {},
        cardImage: {}
      },
      {
        codes: ['-2307'],
        title: '照片拍摄版本过旧，无法验真',
        description:
          '仅支持验证使用今日水印相机「180 天内新版本」拍摄的带水印和防伪码的照片',
        actions: []
      }
    ]
  }
}
